import { loading } from '../constants/sharedCopy';

const getLoadingMessage = loadingType => {
  const defaultLoadingMessage = loading.default;
  return loading[loadingType] || defaultLoadingMessage;
}

export default getLoadingMessage;